import { Component, Input, OnInit } from '@angular/core';
import { ClientsService, Client } from "@admin/clients/clients.service";
import { BehaviorSubject, Subscription } from "rxjs";
import { Router } from '@angular/router';
import { Subscriptions } from '@shared/lib/Subscriptions';
import { MatDialog } from '@angular/material/dialog';

import { AddClientComponent } from "./add-client/add-client.component";
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-nav-admin',
    templateUrl: './nav-admin.component.html',
    styleUrls: ['./nav-admin.component.scss']
})
export class NavAdminComponent implements OnInit {

    @Input('isMosaic') isMosaic: boolean = false;

    public clients: Client[] = [];
    public clientLock: BehaviorSubject<boolean>;
    public activeClient: Client;
    private _subscriptions: Subscription[] = [];
    public activeFilter = "";

    constructor(
        public dialog: MatDialog,
        private _clientService: ClientsService,
        private _snackBar: MatSnackBar
    ) {
        this.clientLock = this._clientService.clientLock
    }

    ngOnInit() {
        this._subscribeToEvents();
    }

    public openDialog(): void {
        let dialogRef = this.dialog.open(AddClientComponent, {
            width: '900px',
            disableClose: true,
            data: {
                clients: this.clients
            }
        });
    }

    _subscribeToEvents() {

        //Listen to when the client list is updated
        this._subscriptions.push(this._clientService.clients.onUpdate()
            .subscribe((clients: Client[]) => {

                //Overwrite current clients
                this.clients = clients

            }))

        //Listen to when the client list is updated
        this._subscriptions.push(this._clientService.clients.onActiveElementChange()
            .subscribe((client: Client) => {

                //Overwrite current active client
                this.activeClient = client;

            }))

        // //Listen to when the client list is updated
        // this._subscriptions.push(this._clientService.clientLock
        //     .subscribe((clientLock: boolean) => {

        //         //Set if the client is locked from swapping
        //         this.clientLock = clientLock;

        //     }))

    }

    ngOnDestroy() {
        Subscriptions.unsubscribe(this._subscriptions)
    }


    selectClient(clientId: string) {

        //Find the selected client
        let index = this.clients.findIndex((client: Client) => {
            return client.clientId == clientId;
        })

        //Set the active client
        if (index >= 0) this._clientService.clients.setActiveElementById(index)

        this.activeFilter = "";
    }

    selectCWC() {
        //Find the selected client
        let index = this.clients.findIndex((client: Client) => {
            return client.isCwc == true;
        })

        //Set the active client
        if (index >= 0) this._clientService.clients.setActiveElementById(index)
    }

    filteredClients(): Client[] {
        return this.clients?.filter((client) => {
            if (!this.activeFilter) return true;
            return client.clientId === this.activeFilter ||
                client?.clientData?.clientName?.toLowerCase()?.includes(this.activeFilter?.toLowerCase()) ||
                client?.clientId?.toLowerCase()?.includes(this.activeFilter?.toLowerCase()
                )
        }) ?? []
    }

}
